import React from "react"
import Links from "../../constants/links"
import SocialLinks from "../../constants/socialLinks"
import styled from "styled-components"

import { FaTimes } from "react-icons/fa"
const Sidebar = ({ isOpen, toggleSidebar, setIsOpen }) => {
  return (
    <SideBar className={`${isOpen ? "show-sidebar" : ""} `}>
      <SideBarToggleButton onClick={toggleSidebar}>
        <FaTimes />
      </SideBarToggleButton>
      <SideBarContainer>
        <Links
          styleClass={`${isOpen ? "sidebar-links2" : ""}`}
          onClick={() => setIsOpen(false)}
        />
        <SocialLinks styleClass={`${isOpen ? "sidebar-icons" : ""}`} />
      </SideBarContainer>
    </SideBar>
  )
}

export default Sidebar

export const SideBar = styled.section`
  background: blue;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: grid;
  place-items: center;
  opacity: 0;
  transition: var(--transition);
  transform: translateX(-100%);

  &.show-sidebar {
    opacity: 1;
    transform: translateX(0);
  }

  @media screen and (min-width: 992px) {
    transform: translateX(-100%);
    opacity: 0;
  }
`
export const SideBarToggleButton = styled.section`
  position: absolute;
  right: 4%;
  top: 2.75%;
  font-size: 1.5rem;
  background: transparent;
  border-color: transparent;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
`
export const SideBarContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 2rem;
`
